import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

/**
 * Shown ~1 minute before inactivity logout.
 * Buttons use theme primary (tenant branding when available).
 */
export default function SessionIdleWarningDialog({
  open,
  remainingSeconds,
  onContinue,
  onLogoutNow,
}) {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      disableAutoFocus
      disableEnforceFocus
      maxWidth="xs"
      fullWidth
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 2000 }}
    >
      <DialogTitle>Session about to expire</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 1 }}>
          You have been inactive. Your session will end in{' '}
          <strong>{Math.max(0, remainingSeconds)}</strong> second
          {remainingSeconds === 1 ? '' : 's'} due to inactivity.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Click <strong>Stay signed in</strong> to continue your work, or you will be signed out
          automatically.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onLogoutNow} color="primary" variant="outlined">
          Sign out now
        </Button>
        <Button onClick={onContinue} variant="contained" color="primary">
          Stay signed in
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SessionIdleWarningDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  remainingSeconds: PropTypes.number,
  onContinue: PropTypes.func.isRequired,
  onLogoutNow: PropTypes.func.isRequired,
};

SessionIdleWarningDialog.defaultProps = {
  remainingSeconds: 60,
};
